d<template>
  <div>
    <user-detail-title
      first-bread="首页管理"
      second-bread="合作伙伴"
      third-bread="合作伙伴添加"
      first-url="/user/quality"
      second-url="/user/partner"
      title-name="合作伙伴添加"
    ></user-detail-title>
    <user-detail-base style="width: 60%;">
      <el-form label-position="left" label-width="100px">
        <el-form-item label="公司名称">
          <el-input v-model="Alist.name"></el-input>
        </el-form-item>
        <el-form-item label="公司logo">
          <el-upload action="/api/photo/uploadFile" :on-success="GetUrlList">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="文字描述">
          <el-input v-model="Alist.description" type="textarea" :row="3"></el-input>
        </el-form-item>
        <el-button @click="handleAdd">添加</el-button>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "../Common/UserDetailBase";
  export default {
    name: "PartnerAdd",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        MenuTree:null,
        defaultProps:{
          children: 'childClassify',
          label: 'name'
        },
        Alist: {
          'name':null,
          'logoAddress':null,
          'description':null,
        },//表示Add添加的数据
      }
    },
    created() {
    },
    methods:{
      GetUrlList(file){
        this.Alist.logoAddress=file.data;
      },
      handleAdd(){
        this.$axios.post('/api/cooperative/add',this.Alist).then(res=>{
          if(res.data.success == true){
            this.Alist= {
              'name':null,
              'logoAddress':null,
              'description':null,
            }//表示Add添加的数据,
            this.$message({
              message:'添加成功',
              type:'success'
            })
          }
        })
      }
    },

  }
</script>

<style scoped>

</style>